import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import strings from 'owa-strings/owa-mail-strings';
/**
 * Get GroupHeader for row in search table
 * @param rowKey rowKey for which we want to lookup time group range
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForSearchTable(rowKey, tableView) {
    var sortOrder = MailRowDataPropertyGetter.getExecuteSearchSortOrder(rowKey, tableView);
    var currentHeaderText = sortOrder == 1 || sortOrder === 'Relevance' ? strings.topResults : strings.allResults;
    return {
        headerText: function () { return currentHeaderText; },
        headerId: currentHeaderText,
    };
}
//# sourceMappingURL=getGroupHeaderForSearchTable.js.map